import moment from "moment";
import React from 'react'
const json = {
    id : '',
    patient_id: '',
    admission_id: '',
    age: '',
    date: moment(new Date()).format("DD-MM-YYYY"),
    department: 'Surgery',
    intern: '',
    diagnosis: '',
    op_date: moment(new Date()).format("DD-MM-YYYY"),
    op_date_operation: moment(new Date()).format("DD-MM-YYYY"),
    op_time_start: moment(new Date()).format("HH:mm"),
    op_time_end: moment(new Date()).format("HH:mm"),
    surgeon: '',
    first_assistant: '',
    second_assistant: '',
    scrub_nurse: '',
    clinical_diagosis: '',
    post_operative_diagnosis: '',
    operative_procedure: '',
    anesthesia: '',
    anesthetist: '',
    surgical_w_classification: '',
    position: '',
    incision: '',
    findings_1: '',
    findings_2: '',
    findings_3: '',
    findings_4: '',
    findings_5: '',
    img_findings_1: '',
    img_findings_2: '',
    img_findings_3: '',
    img_findings_4: '',
    img_findings_5: '',
    procedure: '',
    estimate_blood: '',
    complication: '',
    user_record: '',
    ward:'',
    resident:'',
    staff:'',
    op_note_id : '',
    date_record :  moment(new Date()).format("DD-MM-YYYY"),
    img_findings_1_preview:'',
    img_findings_2_preview:'',
    img_findings_3_preview:'',
    img_findings_4_preview:'',
    img_findings_5_preview:'',
    assistant_name:'',
    name :'',
    surname : '',
    hn: '',
    an:'',
    staff_name :'',
    resident_name:'',
    division:'Trauma',
    gender : ''

}

export default json;
